import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function VariateursPage() {
  const parcours = getOperationIndustrieStub('variateurs');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche IND-UT-114',
        },
        {
          label: 'Moteurs IE3 / IE4',
          href: '/industrie/operations/moteurs-haute-efficacite',
          iconName: 'cog',
          hint: 'Compléter le variateur par un moteur HE',
        },
        {
          label: 'Audit énergétique NF EN 16247',
          href: '/industrie/operations/audit-reglementaire',
          iconName: 'file-search',
          hint: "Identifier les lignes prioritaires",
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
